import React, { useState } from 'react';
import service1 from "../../assets/img/cuartos/CUARTO1.jpg";
import service2 from "../../assets/img/cuartos/CUARTO2.jpg";
import service3 from "../../assets/img/cuartos/CUARTO1.jpg";
import { Link } from 'react-router-dom';

function RoomTable() {
    const rooms = [
        {
            photo: service1,
            title: "Habitación con Cama King",
            description: "Amplia y lujosa habitación con cama king size, perfecta para parejas o viajeros individuales que buscan el máximo confort.",
            capacity: 2
        },
        {
            photo: service2,
            title: "Habitación con Camas Dobles",
            description: "Espaciosa habitación con dos camas dobles, ideal para familias o grupos pequeños que desean compartir espacio.",
            capacity: 4
        },
        {
            photo: service3,
            title: "Habitación Suite",
            description: "Nuestra habitación más exclusiva en el Hotel La Finca, cuenta conáreas espaciosas y todas las comodidades premium.",
            capacity: 2
        }
    ];

    const [roomCounts, setRoomCounts] = useState([0, 0, 0]);

    const handleIncrement = (index) => {
        const newCounts = [...roomCounts];
        newCounts[index] = Math.min(newCounts[index] + 1, 5);
        setRoomCounts(newCounts);
    };

    const handleDecrement = (index) => {
        const newCounts = [...roomCounts];
        newCounts[index] = Math.max(newCounts[index] - 1, 0);
        setRoomCounts(newCounts);
    };

    return (
        <div className="container mt-50 mb-50">

            {/* Desktop Table */}
            <div className="table-responsive d-none d-md-block">
            <div className="about-title second-title pb-25">
                  <h5>Hotel La Finca</h5>
                  <h2 style={{ fontSize: '36px' }}>Habitaciones disponibles</h2>
                  <p>Fechas:</p>

                  </div>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Habitación</th>
                            <th></th>
                            <th>Capacidad Max.</th>
                            <th>Habitaciones</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {rooms.map((room, index) => (
                            <tr key={index}>
                                <td style={{ width: '150px', padding: '10px' }}>
                                    <img 
                                        src={room.photo} 
                                        alt={room.title} 
                                        style={{ width: '100%', height: '100px', objectFit: 'cover', borderRadius: '4px' }} 
                                    />
                                </td>
                                <td style={{ maxWidth: '300px' }}>
                                    <h5 style={{ fontSize: '16px', marginBottom: '5px' }}>{room.title}</h5>
                                    <p className="text-muted" style={{ fontSize: '14px', marginBottom: '0' }}>{room.description}</p>
                                </td>
                                <td className="text-center align-middle">
                                    <div className="d-flex justify-content-center align-items-center">
                                        <span>{room.capacity}</span>
                                        <i className="fal fa-users ml-2"></i>
                                    </div>
                                </td>
                                <td className="text-center align-middle">
                                    <div className="d-flex justify-content-center align-items-center">
                                        <div className="input-group input-group-sm" style={{ width: '100px' }}>
                                            <button
                                                className="btn btn-outline-secondary btn-sm"
                                                type="button"
                                                onClick={() => handleDecrement(index)}
                                            >
                                                -
                                            </button>
                                            <input
                                                type="number"
                                                className="form-control form-control-sm text-center"
                                                value={roomCounts[index]}
                                                readOnly
                                            />
                                            <button
                                                className="btn btn-outline-secondary btn-sm"
                                                type="button"
                                                onClick={() => handleIncrement(index)}
                                            >
                                                +
                                            </button>
                                        </div>
                                    </div>
                                </td>
                                <td className="text-center align-middle">
                                    <div className="d-flex justify-content-center align-items-center">
                                        <Link
                                            to="/reservation-summary"
                                            className={`btn ss-btn btn-sm ${roomCounts[index] === 0 ? 'disabled' : ''}`}
                                        >
                                            RESERVAR
                                        </Link>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Mobile Cards */}
            <div className="d-md-none">
                {rooms.map((room, index) => (
                    <div key={index} className="card mb-4">
                        <img src={room.photo} alt={room.title} className="card-img-top" style={{ height: '180px', objectFit: 'cover' }} />
                        <div className="card-body">
                            <h5 className="card-title">{room.title}</h5>
                            <p className="card-text text-muted" style={{ fontSize: '14px' }}>{room.description}</p>
                            <p className="mb-2"><i className="fal fa-users mr-1"></i> Capacidad: {room.capacity}</p>
                            <div className="d-flex justify-content-center mb-3">
                                <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                                    <button
                                        className="btn btn-sm d-flex justify-content-center align-items-center"
                                        style={{
                                            backgroundColor: '#704727',
                                            color: '#fff',
                                            width: '40px',
                                            height: '40px',
                                            fontSize: '20px',
                                            padding: '0',
                                            borderRadius: '0'
                                        }}
                                        onClick={() => handleDecrement(index)}
                                    >
                                        −
                                    </button>
                                    <input
                                        type="number"
                                        readOnly
                                        className="form-control text-center"
                                        value={roomCounts[index]}
                                        style={{
                                            width: '50px',
                                            height: '40px',
                                            fontSize: '16px',
                                            padding: '0'
                                        }}
                                    />
                                    <button
                                        className="btn btn-sm d-flex justify-content-center align-items-center"
                                        style={{
                                            backgroundColor: '#704727',
                                            color: '#fff',
                                            width: '40px',
                                            height: '40px',
                                            fontSize: '20px',
                                            padding: '0',
                                            borderRadius: '0'
                                        }}
                                        onClick={() => handleIncrement(index)}
                                    >
                                        +
                                    </button>
                                </div>
                            </div>
                            <div className="d-flex justify-content-center">
                                <Link
                                    to="/reservation-summary"
                                    className={`btn ss-btn btn-sm btn-block ${roomCounts[index] === 0 ? 'disabled' : ''}`}
                                >
                                    Reservar
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default RoomTable;
